<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g :clip-path="`url(#${componentId}_clip0_1972_21596)`">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.9788 5.21777C11.9211 5.38097 11.8897 5.55659 11.8897 5.73953C11.8897 6.60398 12.5905 7.30475 13.4549 7.30475H14.2108L9.32801 12.1875C8.71675 12.7988 8.71675 13.7898 9.32801 14.4011C9.93926 15.0123 10.9303 15.0123 11.5416 14.4011L16.4243 9.51831V10.2742C16.4243 11.1386 17.1251 11.8394 17.9896 11.8394C18.279 11.8394 18.55 11.7609 18.7826 11.6239V21.5004C18.7826 22.8811 17.6633 24.0004 16.2826 24.0004H2.5C1.11929 24.0004 0 22.8811 0 21.5004V7.71778C0 6.33706 1.11929 5.21777 2.5 5.21777H11.9788Z"
        :fill="`url(#${componentId}_paint0_linear_1972_21596)`"
      />
      <g :filter="`url(#${componentId}_filter0_b_1972_21596)`">
        <mask :id="`${componentId}_path-2-inside-1_1972_21596`" fill="white">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.1958 0C5.81509 0 4.6958 1.11929 4.6958 2.5V16.2826C4.6958 17.6633 5.81509 18.7826 7.1958 18.7826H20.9784C22.3591 18.7826 23.4784 17.6633 23.4784 16.2826V2.5C23.4784 1.11929 22.3591 0 20.9784 0H7.1958ZM19.0965 4.63236C19.2478 4.78362 19.3616 4.95814 19.438 5.1444L19.5546 5.70755C19.5548 5.71805 19.5549 5.72858 19.5549 5.73914V10.2738C19.5549 11.1382 18.8542 11.839 17.9897 11.839C17.1253 11.839 16.4245 11.1382 16.4245 10.2738V9.51791L11.5417 14.4007C10.9305 15.012 9.93942 15.012 9.32816 14.4007C8.71691 13.7894 8.71691 12.7984 9.32816 12.1871L14.211 7.30435H13.4551C12.5906 7.30435 11.8898 6.60358 11.8898 5.73914C11.8898 4.87469 12.5906 4.17392 13.4551 4.17392H17.9897C18.3903 4.17392 18.7909 4.32673 19.0965 4.63236Z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.1958 0C5.81509 0 4.6958 1.11929 4.6958 2.5V16.2826C4.6958 17.6633 5.81509 18.7826 7.1958 18.7826H20.9784C22.3591 18.7826 23.4784 17.6633 23.4784 16.2826V2.5C23.4784 1.11929 22.3591 0 20.9784 0H7.1958ZM19.0965 4.63236C19.2478 4.78362 19.3616 4.95814 19.438 5.1444L19.5546 5.70755C19.5548 5.71805 19.5549 5.72858 19.5549 5.73914V10.2738C19.5549 11.1382 18.8542 11.839 17.9897 11.839C17.1253 11.839 16.4245 11.1382 16.4245 10.2738V9.51791L11.5417 14.4007C10.9305 15.012 9.93942 15.012 9.32816 14.4007C8.71691 13.7894 8.71691 12.7984 9.32816 12.1871L14.211 7.30435H13.4551C12.5906 7.30435 11.8898 6.60358 11.8898 5.73914C11.8898 4.87469 12.5906 4.17392 13.4551 4.17392H17.9897C18.3903 4.17392 18.7909 4.32673 19.0965 4.63236Z"
          :fill="`url(#${componentId}_paint1_linear_1972_21596)`"
          fill-opacity="0.6"
        />
        <path
          d="M19.438 5.1444L19.9276 5.043L19.9182 4.99758L19.9006 4.95467L19.438 5.1444ZM19.0965 4.63236L19.4501 4.27881L19.45 4.27881L19.0965 4.63236ZM19.5546 5.70755L20.0545 5.69765L20.0536 5.65142L20.0442 5.60614L19.5546 5.70755ZM16.4245 9.51791H16.9245V8.31081L16.0709 9.16436L16.4245 9.51791ZM11.5417 14.4007L11.8953 14.7542L11.5417 14.4007ZM9.32816 14.4007L8.97461 14.7542L8.97461 14.7542L9.32816 14.4007ZM9.32816 12.1871L9.68172 12.5407L9.32816 12.1871ZM14.211 7.30435L14.5645 7.65791L15.4181 6.80435H14.211V7.30435ZM17.9897 4.17392V4.67392H17.9897L17.9897 4.17392ZM5.1958 2.5C5.1958 1.39543 6.09123 0.5 7.1958 0.5V-0.5C5.53895 -0.5 4.1958 0.843148 4.1958 2.5H5.1958ZM5.1958 16.2826V2.5H4.1958V16.2826H5.1958ZM7.1958 18.2826C6.09123 18.2826 5.1958 17.3872 5.1958 16.2826H4.1958C4.1958 17.9395 5.53895 19.2826 7.1958 19.2826V18.2826ZM20.9784 18.2826H7.1958V19.2826H20.9784V18.2826ZM22.9784 16.2826C22.9784 17.3872 22.083 18.2826 20.9784 18.2826V19.2826C22.6353 19.2826 23.9784 17.9395 23.9784 16.2826H22.9784ZM22.9784 2.5V16.2826H23.9784V2.5H22.9784ZM20.9784 0.5C22.083 0.5 22.9784 1.39543 22.9784 2.5H23.9784C23.9784 0.843145 22.6353 -0.5 20.9784 -0.5V0.5ZM7.1958 0.5H20.9784V-0.5H7.1958V0.5ZM19.9006 4.95467C19.7995 4.7082 19.649 4.47774 19.4501 4.27881L18.7429 4.98591C18.8465 5.08951 18.9237 5.20808 18.9754 5.33414L19.9006 4.95467ZM20.0442 5.60614L19.9276 5.043L18.9484 5.24581L19.065 5.80895L20.0442 5.60614ZM20.0549 5.73914C20.0549 5.72527 20.0548 5.71144 20.0545 5.69765L19.0547 5.71744C19.0549 5.72466 19.0549 5.7319 19.0549 5.73914H20.0549ZM20.0549 10.2738V5.73914H19.0549V10.2738H20.0549ZM17.9897 12.339C19.1303 12.339 20.0549 11.4144 20.0549 10.2738H19.0549C19.0549 10.8621 18.578 11.339 17.9897 11.339V12.339ZM15.9245 10.2738C15.9245 11.4144 16.8491 12.339 17.9897 12.339V11.339C17.4014 11.339 16.9245 10.8621 16.9245 10.2738H15.9245ZM15.9245 9.51791V10.2738H16.9245V9.51791H15.9245ZM11.8953 14.7542L16.7781 9.87147L16.0709 9.16436L11.1882 14.0471L11.8953 14.7542ZM8.97461 14.7542C9.78113 15.5608 11.0887 15.5608 11.8953 14.7542L11.1882 14.0471C10.7722 14.4631 10.0977 14.4631 9.68172 14.0471L8.97461 14.7542ZM8.97461 11.8336C8.16809 12.6401 8.16809 13.9477 8.97461 14.7542L9.68172 14.0471C9.26572 13.6311 9.26572 12.9567 9.68172 12.5407L8.97461 11.8336ZM13.8574 6.9508L8.97461 11.8336L9.68172 12.5407L14.5645 7.65791L13.8574 6.9508ZM13.4551 7.80435H14.211V6.80435H13.4551V7.80435ZM11.3898 5.73914C11.3898 6.87972 12.3145 7.80435 13.4551 7.80435V6.80435C12.8668 6.80435 12.3898 6.32744 12.3898 5.73914H11.3898ZM13.4551 3.67392C12.3145 3.67392 11.3898 4.59855 11.3898 5.73914H12.3898C12.3898 5.15083 12.8668 4.67392 13.4551 4.67392V3.67392ZM17.9897 3.67392H13.4551V4.67392H17.9897V3.67392ZM19.45 4.27881C19.0469 3.87564 18.5175 3.67392 17.9897 3.67392L17.9897 4.67392C18.2631 4.67392 18.5348 4.77782 18.7429 4.98592L19.45 4.27881Z"
          :fill="`url(#${componentId}_paint2_linear_1972_21596)`"
          :mask="`url(#${componentId}_path-2-inside-1_1972_21596)`"
        />
      </g>
    </g>
    <defs>
      <filter
        :id="`${componentId}_filter0_b_1972_21596`"
        x="4.23926"
        y="-0.456541"
        width="19.6958"
        height="19.6953"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="0.228271" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1972_21596"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1972_21596"
          result="shape"
        />
      </filter>
      <linearGradient
        :id="`${componentId}_paint0_linear_1972_21596`"
        x1="0.499999"
        y1="24.0004"
        x2="17.5"
        y2="6.5004"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#500C24" />
        <stop offset="0.545" stop-color="#FF1B6B" />
        <stop offset="0.96" stop-color="#FF9DBF" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint1_linear_1972_21596`"
        x1="5.1958"
        y1="18.7826"
        x2="22.1958"
        y2="1.28262"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#500C24" />
        <stop offset="0.545" stop-color="#FF1B6B" />
        <stop offset="0.96" stop-color="#FF9DBF" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint2_linear_1972_21596`"
        x1="7.68569"
        y1="2.1882"
        x2="19.667"
        y2="17.0273"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0.25" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <clipPath :id="`${componentId}_clip0_1972_21596`">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    componentId: {
      type: String,
      default: ''
    }
  }
}
</script>
